import React from "react";
import LayoutBasic from "../../layouts/LayoutBasic";
import ProfilSubpage from "../../modules/ProfilSubpage";

const ProfilPage = () => {
  return (
    <div >
    <LayoutBasic>
      <ProfilSubpage ></ProfilSubpage>
    </LayoutBasic>
    </div>
  );
};

export default ProfilPage;
